module.exports = __webpack_public_path__ + "img/inputTip2_1.09130e42.png";